import {formDataRequest, postRequest} from '../libs/AxiosService.util';

export async function serviceCreateGalleryImage(params) {
    return await formDataRequest('gallery/create', params);
}
export async function serviceUpdateGalleryImage(params) {
    return await formDataRequest('gallery/update', params);
}

export async function serviceGetGalleryImage(params) {
    return await postRequest('gallery', params);
}

export async function serviceDeleteGalleryImage(params) {
    return await formDataRequest('gallery/delete', params);
}
